import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
import { AuthenticationService } from '../services/authentication.service';
import { TRANSLATE } from '../../shared/classes/translatable';
import { AuthService } from '../../shared/services/AuthService';
import { User } from '../../shared/classes/user';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    resetPassword = false
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    mlsSsoActivated: boolean;
    microsoftSsoActivated: boolean;
    microsoftSubmit: boolean;
    token: string;
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private authService: AuthService
    ) {}

    // Is a user logged in?
    get authenticated(): boolean {
        return this.authService.authenticated;
    }
    // The user
    get user(): User {
        return this.authService.user;
    }

    ngOnInit() {
        this.microsoftSubmit = false;
        this.token = '';
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        this.authenticationService.getSSOActivated()
            .subscribe(response => {       
                if (response.data.activated.microsoft_sso === '1') {
                    this.microsoftSsoActivated = true;
                }
            });

        // reset login status
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        if (this.router.url.includes("reset-password")) {
            this.resetPassword = true;
        }

        this.route.queryParams.subscribe(params => {
            if (params['errorMessage']) {
                this.alertService.error(params['errorMessage']);
            }
        })
    }

    // convenience getter for easy access to form fields
    get f(): any { return this.loginForm.controls; }
    /**
     * sign in with microsoft account
     */
    async signIn(): Promise<void> {
        this.microsoftSubmit = true;
        await this.authService.signIn(this.f.username.value);
        this.f.username.value = this.authService.graphUser.mail ? this.authService.graphUser.mail : this.authService.graphUser.userPrincipalName;
        this.f.password.value = this.authService.graphUser.id;

        this.authenticationService.loginMicrosoft(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe(
            retour => {
                this.loading = false;
                if (retour.status === 200) {
                    this.router.navigate([this.returnUrl]);
                    this.alertService.success(TRANSLATE('Connexion autorisée'));
                    this.alertService.info('Consultez la note de mise à jour dans la rubrique Aide');
                    if (retour.data.backup && retour.data.backup === true) {
                        this.alertService.info(TRANSLATE('Base de données sauvegardée'), true);
                    }
                } else {
                    this.alertService.error(retour.message);
                }
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            }
        );
    }
    /**
     * sign in with easy account
     */
    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe(
            retour => {
                this.loading = false;
                if (retour.status === 200) {
                    this.router.navigate([this.returnUrl]);
                    this.alertService.success(TRANSLATE('Connexion autorisée'));
                    this.alertService.info('Consultez la note de mise à jour dans la rubrique Aide');
                    if (retour.data.backup && retour.data.backup === true) {
                        this.alertService.info(TRANSLATE('Base de données sauvegardée'), true);
                    }
                } else {
                    this.alertService.error(retour.message);
                }
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            }
        );
    }


}
